module.exports = __webpack_public_path__ + "img/secretaire-h.4ffa5172.jpg";